"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    QuickActionsChips: ()=>QuickActionsChips
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const analytics_js_namespaceObject = require("./analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const QuickActionsChips = (props)=>{
    const { submitQuickActionMessage, hasOtherMessage, quickActions, isSeparatorMsg } = props;
    const [isQuickActionsDisplayed, setQuickActionsDisplayedValue] = (0, external_react_namespaceObject.useState)(true);
    if (!isSeparatorMsg && (!quickActions || !quickActions.length || hasOtherMessage || !isQuickActionsDisplayed)) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
        flexDirection: "row",
        alignItems: "center",
        p: 2,
        flexWrap: "nowrap",
        style: {
            overflow: 'auto'
        },
        children: quickActions.map((action, i)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                my: 2,
                mx: 1,
                alignItems: "center",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ButtonChip, {
                    size: "md",
                    label: `${action?.emoticon ?? ''} ${action.label}`,
                    color: "text.base",
                    onClick: function() {
                        submitQuickActionMessage(action);
                        setQuickActionsDisplayedValue(false);
                        analytics_js_default().log({
                            label: 'dynamicQuickActions',
                            message: 'QUICK_ACTION_CHIPS_CLICKED',
                            content: action.label
                        });
                    }
                })
            }, `quick-action-button-${i}`))
    });
};
exports.QuickActionsChips = __webpack_exports__.QuickActionsChips;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "QuickActionsChips"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
